import React from 'react';

const VocoContext = React.createContext({
    realDevice : null,
    device : null,
    message : null,
    config : null,
    ioc : null
})

export default VocoContext;
